<priva-title
    class="employee-table--title"
    theme="onlightblue"
    size="md"
    [iconClass]="iconClass"
    [title]="
        employeeGroup().groupName === promotedGroupName
            ? ('GENERAL.TITLE.RECENT' | translate)
            : employeeGroup().groupName
    "
    (click)="onGroupTitleClicked()"
    data-test="employee-group-title"
/>
<priva-table
    class="employee-table"
    [rows]="employeeGroup().employees | employeeSortInGroup: employeeGroup().groupName"
    [disableSelect]="true"
    type="separate"
    [hasHeader]="false"
    (rowClick)="onTableRowClick($event)"
    data-test="employee-group-table"
>
    <ng-template priva-table-column="Number" let-item="row" alignment="end" [width]="60">
        <span data-test="employee-number-cell">{{ item.number }}</span>
    </ng-template>
    <ng-template priva-table-column="Name" let-item="row"> {{ item.name }}</ng-template>
</priva-table>
